import { trackDigitalEvent } from '@sparknz/tracking';

interface TrackErrorScreenParameter {
  errorMessage: string;
  internalErrorCode: number;
  internalErrorMessage: string;
}

export function trackErrorScreen({
  errorMessage,
  internalErrorCode,
  internalErrorMessage,
}: TrackErrorScreenParameter) {
  trackDigitalEvent({
    event: 'component.view',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Component View',
            eventAction: 'component.view',
          },
          attributes: {
            errorMessage,
            internalErrorCode: String(internalErrorCode),
            internalErrorMessage,
          },
        },
      ],
      component: [
        {
          componentInfo: {
            componentID: 'shop.errorMessage',
            componentName: 'Shop Error Message',
          },
          category: {
            primaryCategory: 'Shop',
            subCategory1: 'Error',
          },
        },
      ],
    },
  });
}
